var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.message)?_c('div',{staticClass:"flash-message alert",class:_setup.alertTypeCssClass,attrs:{"id":_vm.id},domProps:{"innerHTML":_vm._s(_setup.message)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }